import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getCookie } from '../../utilities/cookies';
import Loading from '../../components/Loading';

const RedirectPage = () => {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const redirectRaw = params.get("redirect");
    
    try {
      if (!redirectRaw) {
        throw new Error("Missing redirect parameter");
      }
      
      const decodedRedirect = decodeURIComponent(redirectRaw);
      const redirectUrl = new URL(decodedRedirect);
      const cookieValue = getCookie("user");
      
      if (cookieValue) {
        const user = cookieValue;
        
        const pathSegments = redirectUrl.pathname.split('/').filter(Boolean);
        const lastSegment = pathSegments[pathSegments.length - 1];
        if (lastSegment === 'login' || lastSegment === 'signup') {
          pathSegments.pop();
          redirectUrl.pathname = pathSegments.length ? `/${pathSegments.join('/')}` : '/';
        }

        if (user?.user?._id) {
          redirectUrl.searchParams.set("userId", user.user._id);
        }
        if (user?.refreshToken) {
          redirectUrl.searchParams.set("refreshToken", user.refreshToken);
        }
      }
      
      window.location.replace(redirectUrl.toString());
      
    } catch (e) {
      console.error("Redirect error:", e);
      window.location.replace(window.location.origin);
    }
  }, [search]);

  return <Loading />;
};

export default RedirectPage;